import { InfoCircleOutlined } from "@ant-design/icons"
import { Button, Menu, Modal, Table } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { HELP_CENTER_LINK } from "~Shared/config/consts"
import { PROCESS_ENV } from "~Shared/config/env.utils"
import { useAuth } from "~Shared/hooks/auth.hooks"

export const SystemInfo = () => {
    const { isFinwayAdmin } = useAuth()
    const { t } = useTranslation()
    const [isModalVisible, setIsModalVisible] = useState(false)

    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault()
        setIsModalVisible(true)
    }

    const handleModalClose = () => {
        setIsModalVisible(false)
    }

    if (!isFinwayAdmin) {
        return null
    }

    return (
        <>
            <Menu.Item className="max-w-176">
                <a href={HELP_CENTER_LINK} onClick={handleLinkClick}>
                    <InfoCircleOutlined className="text-base" />
                    <span className="ml-0">{t("nav:system_info")}</span>
                </a>
            </Menu.Item>

            <Modal
                title={t("nav:system_info")}
                open={isModalVisible}
                onCancel={handleModalClose}
                destroyOnClose
                width={800}
                footer={[
                    <Button key="close" onClick={handleModalClose}>
                        {t("action:ok")}
                    </Button>,
                ]}
            >
                <Table
                    dataSource={Object.entries(PROCESS_ENV)
                        .sort((a, b) => a[0].localeCompare(b[0]))
                        .map(([key, value]) => ({
                            label: key,
                            value: value || value === 0 || value === false ? String(value) : "N/A",
                        }))}
                    pagination={false}
                >
                    <Table.Column title="KEY" dataIndex="label" key="label" render={(text: string) => <span className="font-bold">{text}</span>} />
                    <Table.Column title="VAL" dataIndex="value" key="value" render={(text: string) => <span className="font-normal break-all">{text}</span>} />
                </Table>
            </Modal>
        </>
    )
}
